import { ParsedUrlQuery } from 'querystring';

export function getQ(query: ParsedUrlQuery) {
    if (query['q']) {
        return query['q'];
    }

    return '';
}
